import './styles.css';

function ComponentPassenger({ data, baby, toEdit, editing }) {
  return (
    <>
      <div className='tabletPassengersPassenger'>
        <div className='tabletPassengersPassengerL'>
          {!baby &&
            <p className='tabletPassengersGroupType'>{data?.key}</p>
          }
          <div className='tabletPassengersGroup'>
            <p className='tabletPassengersGroupKey'>nombre</p>
            <p className='tabletPassengersGroupValue'>{data.name}</p>
          </div>
          <div className='tabletPassengersGroup'>
            <p className='tabletPassengersGroupKey'>apellido</p>
            <p className='tabletPassengersGroupValue'>{data.lastName}</p>
          </div>
          <div className='tabletPassengersGroup'>
            <p className='tabletPassengersGroupKey'>identificacion</p>
            <p className='tabletPassengersGroupValue'>{data.documentNumber}
            </p></div>
            {data.key !== 'CONTACT' &&
          <div className='tabletPassengersGroup'>
            <p className='tabletPassengersGroupKey'>genero</p>
            <p className='tabletPassengersGroupValue'>{data.gender}</p>
          </div>}

          {data.key !== 'CONTACT' &&
          <div className='tabletPassengersGroup'>
            <p className='tabletPassengersGroupKey'>fecha de nacimiento</p>
            <p className='tabletPassengersGroupValue'>{data.birth}</p>
          </div>
          }
          {data.key === 'CONTACT' &&
            <div className='tabletPassengersGroup'>
              <p className='tabletPassengersGroupKey'>Email</p>
              <p className='tabletPassengersGroupValue'>{data.email}</p>
            </div>
          }
          {data.key === 'CONTACT' &&
            <div className='tabletPassengersGroup'>
              <p className='tabletPassengersGroupKey'>Teléfono</p>
              <p className='tabletPassengersGroupValue'>{data.codePhone} - {data.numberPhone}</p>
            </div>
          }
          {data.key === 'CONTACT' &&
            <div className='tabletPassengersGroup'>
              <p className='tabletPassengersGroupKey'>Dirección</p>
              <p className='tabletPassengersGroupValue'>{data.address}</p>
            </div>
          }
        </div>
        <div className='tabletPassengersPassengerR'>
          {
            editing &&
            <div className='tabletPassengersBtnEdit' onClick={() => toEdit(data)}>
              <p className='tabletPassengersBtnEditText'>Editar</p>
            </div>
          }
        </div>
      </div>
      {
        data.baby &&
        <div className='tabletPassengersContainerBaby'>
          <p className='tabletPassengersGroupType'
          >{data.name} lleva en brazos a:</p>
          <ComponentPassenger data={data.baby} baby={true} toEdit={toEdit} editing={editing} />
        </div>
      }
    </>
  )
}


function TabletPassengers({
  list,
  toEdit = () => { },
  editing = false,
  title,
}) {


  console.log("............list",list)
  return (
    <div className='tabletPassengers'>
      <div className='tabletPassengersHead'>
        <p className='tabletPassengersHeadTitle'>{title}</p>
      </div>
      <div className='tabletPassengersBody'>
        {
          list && list.map((index, key) => {
            return (
              <ComponentPassenger
                key={key}
                data={index}
                baby={false}
                toEdit={toEdit}
                editing={editing}
              />
            )
          })
        }
      </div>
    </div>
  )
}

export default TabletPassengers;
